import type { CSSProperties } from "react";

// Shared layout values for the peripheral association modal.
// Tied to .modal-assoc__clz (max-height: 89vh) and modal-wrapper__clz
// (height: 95vh) in src/pages/Applications/index.css.

// Right-pane card cap — keeps the grid row height stable so the left Nav
// (red sidebar) doesn't grow when a peripheral is added.
export const PERIPHERAL_FORM_CARD_STYLE: CSSProperties = {
    maxHeight: "720px",
    overflowY: "auto",
};

// Outer grid sizing for the associate modal body. minHeight is derived
// from modal height (90vh) minus header (~70px) and bottom breathing
// room (~140px) so the Nav stays at a fixed visual height.
export const ASSOCIATE_MODAL_GRID_HEIGHT = "96%";
export const ASSOCIATE_MODAL_GRID_MIN_HEIGHT = "calc(90vh - 210px)";

// Left Nav (red sidebar) height inside the associate modal. When a peripheral
// is being added the right pane gains its own breathing room (marginBottom),
// so the Nav is slightly shortened to keep both panes visually aligned within
// the capped modal height (.modal-assoc__clz / modal-wrapper__clz in index.css).
export const NAV_HEIGHT_WITH_PERIPHERAL = "94%";
export const NAV_HEIGHT_DEFAULT = "100%";
